module.exports = __webpack_public_path__ + "img/community.793fa89f.png";